/**
 * The tray tracks selections as `{ [id]: boolean }`; the batch API wants the checked ids.
 */
export const selectedIds = (selectionObject = {}) => Object.entries(selectionObject)
  .filter(([, checked]) => !!checked)
  .map(([id]) => parseInt(id, 10));
